export const moneyFormatter = new Intl.NumberFormat(
    "en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })

export const moneyFormatterCents = new Intl.NumberFormat(
    "en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    })

export function onChangeMoneyField(field:any, e: any) {
    const inputValue = e.target.value;

    const rawValue = inputValue.replace(/[$,]/g, "");
    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
        field.onChange(parsedValue.toString());
    } else {
        field.onChange("");
    }
};


export const dateFormatter = new Intl.DateTimeFormat(
    "en-US", {
        dateStyle: 'short',

    });

export function formatDate (dateString: string | Date | undefined){
    if(!dateString){
        return "";
    }
    const date = new Date(dateString);
    return date.toLocaleDateString();
};